import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=74003855&scoped=true&"
var script = {}
import style0 from "./Info.vue?vue&type=style&index=0&id=74003855&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74003855",
  null
  
)

export default component.exports